import type { UploadDateRange } from "@/stores/documents/repository";

/**
 * Whether a document added at `createdAt` falls in an added-date range — the
 * same half-open test the queries apply (from inclusive, to exclusive), for
 * rows a view filters client-side.
 */
export function matchesUploadDateRange(
  createdAt: string | null | undefined,
  range: UploadDateRange | undefined
): boolean {
  if (!range || (!range.from && !range.to)) return true;
  if (!createdAt) return false;
  const at = Date.parse(createdAt);
  if (Number.isNaN(at)) return false;
  if (range.from && at < Date.parse(range.from)) return false;
  if (range.to && at >= Date.parse(range.to)) return false;
  return true;
}
